import { FeatureSettings, FeatureContext } from '@/contexts/feature/helpers';
import { useContext } from 'react';

const useFeature = () => useContext<FeatureSettings>(FeatureContext);

export default useFeature;
